/**
 * Nsection B12 Service
 * B.12.洩漏 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b12';

export interface FormulaParameter {
  symbol: string;
  para_type?: number | null;
  scenarios: string;
  unit: string;
  annual_value: number | null;
}

export interface FormulaEntry {
  id: string;
  equation_note: string;
  equation: { latex: string };
  parameters: FormulaParameter[];
  calculation_result: { value: number | null; unit: string };
}

export interface NsectionB12Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  leakage_sources: string | null;
  leakage_avoidance: string | null;
  leakage_calculate: FormulaEntry[] | null;
  nsection_b12_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB12Update {
  leakage_sources?: string;
  leakage_avoidance?: string;
  leakage_calculate?: FormulaEntry[];
}

const nsectionB12Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB12Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB12Update): Promise<NsectionB12Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB12Service;
